export default __webpack_public_path__ + "static/SR India - 2022 General Conditions of Sale-b4ac6b72fc76b60f3fed9e8b2e5cff5b.pdf";